var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33331 2.66659L6.19998 1.58325C6.32665 1.42525 6.51798 1.33325 6.72065 1.33325H9.27998C9.48265 1.33325 9.67398 1.42525 9.80065 1.58325L10.6666 2.66659V2.66659V3.33325C10.6666 3.70125 10.368 3.99992 9.99998 3.99992H5.99998C5.63198 3.99992 5.33331 3.70125 5.33331 3.33325V2.66659V2.66659H5.33331Z",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33335 2.66675H4.00002C3.26335 2.66675 2.66669 3.26341 2.66669 4.00008V12.6667C2.66669 13.4034 3.26335 14.0001 4.00002 14.0001H12C12.7367 14.0001 13.3334 13.4034 13.3334 12.6667V4.00008C13.3334 3.26341 12.7367 2.66675 12 2.66675H10.6667",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 7.33333H10.6666",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 10.6666H10.6666",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDraft);
export default __webpack_public_path__ + "static/media/status-draft.b7eb6d454675373e4e9da996982467d4.svg";
export { ForwardRef as ReactComponent };